const tabSliderIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5975 1.53659H6.4024C5.69521 1.53659 5.12191 2.10988 5.12191 2.81707V18.1829C5.12191 18.8901 5.69521 19.4634 6.4024 19.4634H14.5975C15.3047 19.4634 15.878 18.8901 15.878 18.1829V2.81707C15.878 2.10988 15.3047 1.53659 14.5975 1.53659ZM6.4024 0C4.84657 0 3.58533 1.26125 3.58533 2.81707V18.1829C3.58533 19.7388 4.84657 21 6.4024 21H14.5975C16.1533 21 17.4146 19.7388 17.4146 18.1829V2.81707C17.4146 1.26125 16.1533 0 14.5975 0H6.4024Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.60976 3.07318H2.81707C2.10988 3.07318 1.53659 3.64647 1.53659 4.35366V16.6463C1.53659 17.3535 2.10988 17.9268 2.81707 17.9268H4.60976V19.4634H2.81707C1.26125 19.4634 0 18.2022 0 16.6463V4.35366C0 2.79784 1.26125 1.53659 2.81707 1.53659H4.60976V3.07318Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9025 19.4634H18.183C19.7388 19.4634 21 18.2022 21 16.6463V4.35366C21 2.79784 19.7388 1.53659 18.183 1.53659H16.9025V3.07318H18.183C18.8901 3.07318 19.4634 3.64647 19.4634 4.35366V16.6463C19.4634 17.3535 18.8901 17.9268 18.183 17.9268H16.9025V19.4634Z"
      fill="#6B00DF"
    />
  </svg>
);

const tabSlideIcon = (
  <svg
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_644_97)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1829 1.5H2.81707C2.10988 1.5 1.53659 2.05964 1.53659 2.75V13.25C1.53659 13.9404 2.10988 14.5 2.81707 14.5H18.1829C18.8901 14.5 19.4634 13.9404 19.4634 13.25V2.75C19.4634 2.05964 18.8901 1.5 18.1829 1.5ZM2.81707 0C1.26125 0 0 1.23122 0 2.75V13.25C0 14.7688 1.26125 16 2.81707 16H18.1829C19.7388 16 21 14.7688 21 13.25V2.75C21 1.23122 19.7388 0 18.1829 0H2.81707Z"
        fill="#6B00DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.622 5H5.37805C5.23661 5 5.12195 5.11193 5.12195 5.25V7.75C5.12195 7.88807 5.23661 8 5.37805 8H15.622C15.7634 8 15.878 7.88807 15.878 7.75V5.25C15.878 5.11193 15.7634 5 15.622 5ZM5.37805 3.5C4.38798 3.5 3.58537 4.2835 3.58537 5.25V7.75C3.58537 8.7165 4.38798 9.5 5.37805 9.5H15.622C16.612 9.5 17.4146 8.7165 17.4146 7.75V5.25C17.4146 4.2835 16.612 3.5 15.622 3.5H5.37805Z"
        fill="#6B00DF"
      />
      <path
        d="M3.58537 11.75C3.58537 11.3358 3.92934 11 4.35366 11H16.6463C17.0707 11 17.4146 11.3358 17.4146 11.75C17.4146 12.1642 17.0707 12.5 16.6463 12.5H4.35366C3.92934 12.5 3.58537 12.1642 3.58537 11.75Z"
        fill="#6B00DF"
      />
    </g>
    <defs>
      <clipPath id="clip0_644_97">
        <rect width="21" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { tabSliderIcon, tabSlideIcon };
